import { Image } from '@cian/ui-kit/image';
import React from 'react';
import classNames from 'classnames';

import { IMedia, LazyLoadTypes } from '../../../../../packages/Carousel/shared/types';
import { Carousel } from '../../../../../packages/Carousel/shared';

import styles from './Gallery.css';

interface ICarouselProps {
  media: IMedia[];
  renderMediaDelay: number;
  onChangeSlide(): void;
}

export function Gallery({ media, onChangeSlide, renderMediaDelay }: ICarouselProps) {
  const [lazyLoad, setLazyLoad] = React.useState<LazyLoadTypes | undefined>('ondemand');
  const renderMediaTimeoutHandler = React.useRef<ReturnType<typeof setTimeout> | null>(null);

  const handleMouseEnter = React.useCallback(() => {
    if (renderMediaTimeoutHandler.current) {
      clearTimeout(renderMediaTimeoutHandler.current);
    }

    renderMediaTimeoutHandler.current = setTimeout(() => {
      renderMediaTimeoutHandler.current = null;

      setLazyLoad(undefined);
    }, renderMediaDelay);
  }, []);

  const handleMouseLeave = React.useCallback(() => {
    if (renderMediaTimeoutHandler.current) {
      clearTimeout(renderMediaTimeoutHandler.current);
    }
  }, []);

  if (media.length === 0) {
    return (
      <div className={classNames(styles['cont'], styles['cont--empty'])}>
        <Image src="" />
      </div>
    );
  }

  return (
    <div
      className={styles['cont']}
      data-media-count={media.length}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <Carousel media={media} afterChange={onChangeSlide} lazyLoad={lazyLoad} />
    </div>
  );
}
